import {​ RxTransferService }​ from "./../../../services/rx-transfer.service";
import {
    PharmacyData,
    XferInfoDet,
    XferInfoEdit
}​ from "./../../../models/rxTransfer.model";
import {​ FormBuilder, FormGroup }​ from "@angular/forms";
import {​ NgbModal }​ from "@ng-bootstrap/ng-bootstrap";
import {​
    Component,
    OnInit,
    ViewChild,
    Output,
    EventEmitter,
    Input,
    HostListener,
    inject
}​ from "@angular/core";
import {​ City, RxTransfer, RxTransferInOut, SearchNoteParams, State }​ from "../../../models";
import {​ RxTransferInComponent }​ from "../../shared";
import {​ RxStore }​ from "src/app/store";
import {​ PrintService }​ from "src/app/services/print.service";
import * as moment from "moment";
import {​ CollectionView }​ from "@grapecity/wijmo";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormatsUtil } from "src/app/utils/formats.util";
import { environment } from "src/environments/environment";
import { PharmacyLabels } from "src/app/models/labels.models";
import { MsgConfig } from "src/app/app.messages";
import { PatientInfoUtil } from "src/app/utils/patient-info.util";
import { AlertService, CommonService, DrugService, NotesLogService, UserService } from "src/app/services";
import { NotesMainCat } from "src/app/models/notes.enum";
import { CommonUtil, NewAuditUtils, WijimoUtil } from 'src/app/utils';
import { StorageService } from "src/app/services/storage.service";
@Component({​
    selector: "app-tr-rx-in-only",
    templateUrl: "./tr-rx-in-only.component.html"
}​)
export class TrRxInOnlyComponent implements OnInit {​
    @Input() rxType: string;
    @Input() rxFG: FormGroup;
    @Input() prevSaved: any;
    @Input() IsFromVerification: string;
    modalRef: any;
    rxTransferInfo: RxTransfer = new RxTransfer();
    Phone: any;
    saveRXIN = false;
    refillDetails: any;
    PharmacyNames: any;
    selectedPharmacist: string;
    pharmcyDet: PharmacyData = new PharmacyData();
    pharmacyabels = new PharmacyLabels();
    msgConfig = MsgConfig;
    activeModal = "";
    transferType =  false;
    RXINPOPUP: boolean;
    formGroupInvalid = false;
    @Output()
    IsPopUpClosed = new EventEmitter<null>();
    @ViewChild(RxTransferInComponent)
    rxTransferInComponent: RxTransferInComponent;
    @ViewChild("RXINMODAL", {​ static: true }​)
    RXINMODAL: any;
    @ViewChild("NOTRX", {​ static: true }​)
    NOTRX: any;
    @ViewChild("INDETAILS", {​ static: true }​)
    INDETAILS: any;
    @ViewChild("XEREDIT", {​ static: true }​)
    XEREDIT: any;
    @ViewChild("RXDETAILMODAL", {​ static: true}​)
    RXDETAILMODAL: any;
    @ViewChild("TRANSFERINFO", {​ static: true}​)
    TRANSFERINFO: any;
    @ViewChild("FAXCHANGE", { static: true })
    FAXCHANGE: any;    
    @ViewChild("UPDATE", { static: true })
    UPDATE: any;
    notTransfered: boolean;
    rxTransferFG: FormGroup;
    recvRph: any;
    Phone1: any;
    Phone2: any;
    Fax: any;
    public citySelected = null;
    public stateSelected = null;
    transferDWJ: CollectionView;
    activeHeaders: any[];
    bothTransferViewModal: any;
    rxTransferDetails: any;
    pharmacyList: any;
    refillNos: string;
    rxTransferType: string;
    unsubscribe$ : Subject<void> = new Subject();
    transferoutResponse: boolean;
    faxFG: FormGroup;
    isFaxchanged: boolean;
    subscriptions = new Subscription();
    prtObj: any;
    oldFax: any;
    modalRef2: any;
    modalRef3: any;
    isIvrEnabled = environment.isIvrEnabled;
    originalTransferInfo: any;
    isNotesInvalid: boolean = false;
    private _auditUtils = inject(NewAuditUtils);

    @HostListener("window:keyup", ["$event"])
    keyEvent(event: KeyboardEvent) {​
      if (event.which === 27) {​
          if (this.activeModal === "NOTRX" || this.activeModal === "INDETAILS" || this.RXINPOPUP) {​
              this.closeModal();
          }​
      }​
    }​
    constructor(
        private _modalService: NgbModal,
        private _rxTransferDet: RxTransferService,
        private _patientUtil: PatientInfoUtil,
        private _rxStore: RxStore, 
        private _notesLogSvc: NotesLogService,
        private _fb: FormBuilder, 
        public _formatsUtil: FormatsUtil,
        public _commonServ: CommonService,
        private _drugServ: DrugService,
        private _rxSer: RxTransferService,
        private _userService: UserService,
        private _alertService: AlertService,
        private _printser: PrintService,
        private _comnUtil: CommonUtil,
        private _wijimoUtils: WijimoUtil,
        public _storageService: StorageService,
    ) {​}​
    ngOnInit() {​
        this.patchDefaultValHeaders();
        this._wijimoUtils.wjSavedData$.pipe(takeUntil(this.unsubscribe$)).subscribe(w => {
        if (w && w["WijmoKey"] && w["WijmoKey"] === "rxTransferListWj") {
          this.patchDefaultValHeaders();
        }
        });
        this.rxTransferType = environment.IseRxTransferRequest ? "MarkTransferIn" : '';
        this.transferoutResponse = environment.transferoutResponse;
        this.patchPatientInfo();
        this.patchPrescbrInfo();
        this.patchDrugInfo();
        this.patchRxInfo();
        if (this.rxType === "er" || this.IsFromVerification === 'vrf' || (this.rxType === "nrf" && (this.rxFG.value['fileToFill'] && this.rxFG?.value?.PrescReFill?.StatusId === 3 || this.rxFG?.value?.Prescription?.RxStatusId === 3))) {​
            this.alreadySavedRxIn();
        }​ else {​
            this.openRXIN();
        }​
        this.faxFG = this._fb.group({
            fax: [null],
            tofax: [null]
        });
        this.isIvrEnabled = environment.isIvrEnabled && localStorage.getItem("IvrGUIDDetails") ? true : false;
    }​

    async patchDefaultValHeaders() {
        const storedrxTWJ = await this._wijimoUtils.getWJSavedData("rxTransferListWj");
        this.activeHeaders = await this._wijimoUtils.patchDefHeader("rxTransferListWj", storedrxTWJ);
    }

    selectedRphValue(e) {​
        this.recvRph = e?.value?.PharmacistName;
    }​
    async getRxTransferPopups() {​
        const resp = await this._rxTransferDet.getRxTransferPopups(
                        this.Prescription.value["PrescNum"], false, this.PrescReFill.value["ReFillNum"], this.PrescReFill.value["PartialFillNo"]).toPromise();
        if (resp && (resp === 3 || resp === 4)) {​
            this.alreadySavedRxIn();
        }​ else {​
            this.openRXIN();
        }​
    }​
    patchPatientInfo() {​
        const patient = this.rxFG.get("Patient").value;
        if (patient) {​
            this.rxTransferInfo.PatientName = patient.fullname ? patient.fullname.replace("_", ", ") : null;
            this.rxTransferInfo.DateOfBirth = patient.dob ? patient.dob : null;
            this.rxTransferInfo.Gender = patient.gender ? patient.gender : null;
            this.rxTransferInfo.PatientAddress = patient.fulladdress ? patient.fulladdress: null;
        }​
    }​
    patchPrescbrInfo() {​
        const prescriber = this.rxFG.get("Prescriber").value;
        if (prescriber) {​
            this.rxTransferInfo.PrescriberName = ((prescriber?.prescriberlastname ? prescriber.prescriberlastname : null) + ", " + (prescriber?.prescriberfirstname ? prescriber.prescriberfirstname : null));
            this.rxTransferInfo.DEA = prescriber.prescriberdeanum
                ? prescriber.prescriberdeanum : null;
            this.rxTransferInfo.NPINum = prescriber.prescribernpinum
                ? prescriber.prescribernpinum : null;
            this.rxTransferInfo.Licencenumber = prescriber.prescriberlicensenumber
                ? prescriber.prescriberlicensenumber : null;
            this.Phone = prescriber.telephone ? prescriber.telephone : null;
            this.rxTransferInfo.Fax = null;
        }​
    }​
    patchDrugInfo() {​
        const drug = this.rxFG.get("Drug").value;
        if (drug) {​
            this.rxTransferInfo.DrugDetail = drug.drugname + " " + drug.strength + " " + drug.drugformname;
            this.rxTransferInfo.NDC = drug.drugcode ? drug.drugcode : null;
            this.rxTransferInfo.AWP = drug.awppack ? drug.awppack : null;
            this.rxTransferInfo.PacketSize = drug.qtypack ? drug.qtypack : null;
        }​
    }​
    patchRxInfo() {​
        const rxInfo = this.rxFG.getRawValue();
        this.rxTransferInfo.Aref = rxInfo.Prescription.ReFillNum;
        this.rxTransferInfo.Qty = rxInfo.PrescReFill.OrdQty;
        this.rxTransferInfo.Days = rxInfo.PrescReFill.OrderDays;
        this.rxTransferInfo.SigDescription = rxInfo.SigCodes.Description;
        this.rxTransferInfo.Refillno = rxInfo.PrescReFill.ReFillNum;
        this.rxTransferInfo.Refillsleft = rxInfo.Prescription.RxStatusId === 4 ? 0 :
        rxInfo.Prescription.ReFillNum - rxInfo.PrescReFill.ReFillNum;
        this.rxTransferInfo.OriginalRxDate = rxInfo.PrescReFill.OrderDtTm;
        this.rxTransferInfo.RxFillDate = rxInfo.PrescReFill.FillDtTm;
        this.rxTransferInfo.InsurerCode = rxInfo.RefillInsu.InsuId;
        this.rxTransferInfo.RxStatusId = rxInfo["RxBill"]["RxStatusId"];
        this.rxTransferInfo.DispQty = rxInfo.PrescReFill.DispQty;
        if (rxInfo.PrescReFill.StatusId === 4 || rxInfo.Prescription.RxStatusId === 4 ) {​
            this.transferType = true;
            this.notTransfered = false;
        }​ else if (rxInfo.PrescReFill.StatusId === 3 || rxInfo.Prescription.RxStatusId === 3) {​
            this.transferType = false;
            this.notTransfered = false;
        }​ else  {​
            this.notTransfered = true;
        }​
    }​
    async alreadySavedRxIn() {​
        if (this.notTransfered) {​
            this.modalRef = this._modalService.open(this.NOTRX, {​
                centered: true, keyboard: false, backdrop: false, windowClass: "large--content"
            }​);
            this.activeModal = "NOTRX";
        }​ else {​
            await this.getPharmacyList();
            this.getTranferDet();
        }​
    }​
    async getTranferDet() {​
        const resp = await this._rxTransferDet.getTransferInDetails(
            this.Prescription.value["Id"], this.PrescReFill.value["ReFillNum"], this.transferType).toPromise();
        if (resp) {​
            this.rxTransferDetails = resp;
            if (resp["rxTransferIn"] && resp["rxTransferOut"]) {​
                await this.generateTransferWJ(resp);
                sessionStorage.setItem("fromPaGrid","true");
                this.bothTransferViewModal =  this._modalService.open(this.RXDETAILMODAL , {​backdrop: false, centered: true, windowClass: 'mode_width_rx_transfer'}​);
            }​ else {​
                this.openDetailTransferDet(resp);
            }​
        }​
    }​
    async getPharmacyList() {​
        this.pharmacyList = await this._rxTransferDet.getPharmacyNames().toPromise();
    }​
    findPharmacyName(Id) {​
        let result = null;
        if (this.pharmacyList && this.pharmacyList["pharmNames"] && this.pharmacyList["pharmNames"]["pharmNamesViewModels"] &&
         this.pharmacyList["pharmNames"]["pharmNamesViewModels"].length) {​
            const data = this.pharmacyList["pharmNames"]["pharmNamesViewModels"].find(v => v["Id"] === Id);
            result = data ? data["PharmacyName"] : null;
        }​
        return result;
    }​
    generateTransferWJ(data) {​
        const result = [];
        const k = {​}​;
        k["Rx#"] = this.Prescription.value["PrescNum"];
        k["Refills Transferred"] = data["rxTransferIn"]["RefillsReceived"];
        k["Transfer Type (In/Out)"] = "I";
        k["Transfer Pharmacy"] = this.findPharmacyName(data["rxTransferIn"]["XferPharmId"]);
        k["From RPh"] = data["rxTransferIn"]["PharmacistName"];
        k["To RPh"] = data["rxTransferIn"]["OrgPharmacistNm"];
        k["Org Rx#"] = data["rxTransferIn"]["OrgRxNum"];
        k["Org Rx Date"] = moment.utc(data["rxTransferIn"]["OrgRxDtTm"]).local().format("MM/DD/YYYY");
        k["Fill Date"] = moment.utc(data["rxTransferIn"]["OrgLastRxFillDtTm"]).local().format("MM/DD/YYYY");
        k["Transfer Date"] = moment.utc(data["rxTransferIn"]["TransferDtTm"]).local().format("MM/DD/YYYY");
        result.push(k);
        const j = {​}​;
        j["Rx#"] = this.Prescription.value["PrescNum"];
        j["Refills Transferred"] = data["rxTransferOut"]["RefillsTransferred"];
        j["Transfer Type (In/Out)"] = "O";
        j["Transfer Pharmacy"] = this.findPharmacyName(data["rxTransferOut"]["XferPharmId"]);
        j["From RPh"] = data["rxTransferOut"]["PharmacistName"];
        j["To RPh"] = data["rxTransferOut"]["OrgPharmacistNm"];
        j["Org Rx#"] = 0;
        j["Org Rx Date"] = moment.utc(data["rxTransferOut"]["OrgRxDtTm"]).local().format("MM/DD/YYYY");
        j["Fill Date"] = moment.utc(data["rxTransferOut"]["OrgLastRxFillDtTm"]).local().format("MM/DD/YYYY");
        j["Transfer Date"] = moment.utc(data["rxTransferOut"]["TransferDtTm"]).local().format("MM/DD/YYYY");
        result.push(j);
        this.transferDWJ = new CollectionView(result);
    }​
    openEditView(Type) {​
        this.transferType = Type === "I" ? false : true;
        this.closeDetailModal();
        this.openDetailTransferDet(this.rxTransferDetails);
    }​
    closeDetailModal(type?: any) {​
        if (this.bothTransferViewModal) {​
            this.bothTransferViewModal.close();
            sessionStorage.setItem("fromPaGrid","false");
        }​
        this.bothTransferViewModal = null;
        if (type) {​
            this.IsPopUpClosed.emit(null);
        }​
    }​
    async openDetailTransferDet(resp) {​
        this.createXerFG();
        this.patchTransferDetFG(resp);
        this.refillDetails = resp;
        if (this.pharmacyList && this.pharmacyList["pharmNames"]) {
            const resp2 = Object.assign({​}​, this.pharmacyList);
            if (resp2) {​
                this.PharmacyNames = resp2;
                this.PharmacyNames.pharmNames = this.arrangePharmDet(resp2["pharmNames"]);
            }​
        }
        await this.getPharmcyDetails();
       if(environment.IseRxTransferRequest){
        this.modalRef = this._modalService.open(
            this.TRANSFERINFO, {​ centered: true, size: "lg", windowClass: this.IsFromVerification ? 'markasTransferIn_Vfr' : "markasTransferIn_ediRx", keyboard: false }​);
       } else {
             this.modalRef = this._modalService.open(
            this.XEREDIT, {​ centered: true, size: "lg", windowClass: "md-x-lg", keyboard: false }​);
       }
        this.activeModal = "INDETAILS";
    }​
    arrangePharmDet(data) {​
        let pharmaDetails = [];
        if (data && data["pharmNamesViewModels"] && data["pharmNamesViewModels"].length) {​
            pharmaDetails = data["pharmNamesViewModels"].map(v => {​
                const k = {​}​;
                k["Id"] = v["Id"];
                k["PharmacyName"] = v["PharmacyName"];
                let phoneDet = null;
                if (data["Phones"] && data["Phones"].length) {​
                    phoneDet = data["Phones"].filter(d => d["Id"] === v["Id"]);
                }​
                if (phoneDet && phoneDet.length) {​
                    const ph12 = phoneDet.filter(pd => pd["PhoneCatId"] === 3);
                    k["Phone1"] = ph12 && ph12.length ? ph12[0]["Phone"] : null;
                    k["Phone2"] = ph12 && ph12.length > 1 ? ph12[1]["Phone"] : null;
                    const fax = phoneDet.filter(pd => pd["PhoneCatId"] === 4);
                    k["Fax"] = fax && fax.length ? fax[0]["Phone"] : null;
                }​ else {​
                    k["Phone1"] = null;
                    k["Phone2"] = null;
                    k["Fax"] = null;
                }​
                return k;
            }​);
        }​
        return pharmaDetails;
    }​
    createXerFG() {​
        this.rxTransferFG = this._fb.group(new XferInfoDet());
    }​
    patchTransferDetFG(data) {​
        const rxInfo = this.rxFG.getRawValue();
        this.rxTransferFG.patchValue(this.transferType ? data["rxTransferOut"] : data["rxTransferIn"]);
        const trnsRxDtTm  = new Date(this.rxTransferFG.value["TransferDtTm"]);
        const trnsRxDtTmFrmt = `${trnsRxDtTm.getHours()} : ${trnsRxDtTm.getMinutes()} : ${trnsRxDtTm.getMilliseconds()}`;
        const ordRxDtTm = new Date(this.rxTransferFG.value["OrgRxDtTm"]);
        const ordRxDtTmFrmt = `${ordRxDtTm.getHours()} : ${ordRxDtTm.getMinutes()} : ${ordRxDtTm.getMilliseconds()}`;
        const orgLastDtTm = new Date(this.rxTransferFG.value["OrgLastRxFillDtTm"]);
        const ordLastDtTmFrmt = `${orgLastDtTm.getHours()} : ${orgLastDtTm.getMinutes()} : ${orgLastDtTm.getMilliseconds()}`;
        const ordDtTm = new Date(rxInfo.PrescReFill.OrderDtTm);
        const ordDtTmFrmt = `${ordDtTm.getHours()} : ${ordDtTm.getMinutes()} : ${ordDtTm.getMilliseconds()}`;
        const fillDtTm = new Date(rxInfo.PrescReFill.FillDtTm);
        const fillDtTmFrmt = `${fillDtTm.getHours()} : ${fillDtTm.getMinutes()} : ${fillDtTm.getMilliseconds()}`;
        this.rxTransferFG.patchValue({​
            prescnumid: this.rxFG.value["Prescription"]["PrescNum"],
            OrgRxDtTm: (this.rxTransferFG.value["OrgRxDtTm"] && this.rxTransferFG.value["OrgRxDtTm"] === "0001-01-01T00:00:00" ?
            (rxInfo.PrescReFill.OrderDtTm && ordDtTmFrmt !== "0 : 0 : 0" ? moment.utc(rxInfo.PrescReFill.OrderDtTm).local().format("MM/DD/YYYY") :  moment.utc(rxInfo.PrescReFill.OrderDtTm).format("MM/DD/YYYY")):
            (this.rxTransferFG.value["OrgRxDtTm"] && ordRxDtTmFrmt !== "0 : 0 : 0" ? moment.utc(this.rxTransferFG.value["OrgRxDtTm"]).local().format("MM/DD/YYYY") : moment.utc(this.rxTransferFG.value["OrgRxDtTm"]).format("MM/DD/YYYY"))),
            OrgLastRxFillDtTm: (this.rxTransferFG.value["OrgLastRxFillDtTm"] &&
            this.rxTransferFG.value["OrgLastRxFillDtTm"] === "0001-01-01T00:00:00" ?
            (rxInfo.PrescReFill.FillDtTm && fillDtTmFrmt !== "0 : 0 : 0" ?  moment.utc(rxInfo.PrescReFill.FillDtTm).local().format("MM/DD/YYYY") : moment.utc(rxInfo.PrescReFill.FillDtTm).format("MM/DD/YYYY")):
            (this.rxTransferFG.value["OrgLastRxFillDtTm"] && ordLastDtTmFrmt !== "0 : 0 : 0" ? moment.utc(this.rxTransferFG.value["OrgLastRxFillDtTm"]).local().format("MM/DD/YYYY") : moment.utc(this.rxTransferFG.value["OrgLastRxFillDtTm"]).format("MM/DD/YYYY"))),
            TransferDtTm: (this.rxTransferFG && this.rxTransferFG.value["TransferDtTm"] && trnsRxDtTmFrmt !== "0 : 0 : 0" ?
            moment.utc(this.rxTransferFG.value["TransferDtTm"]).local().format("MM/DD/YYYY") : moment.utc(this.rxTransferFG.value["TransferDtTm"]).format("MM/DD/YYYY")),
            OrgPharmacistNm: this.transferType ? this.rxTransferFG.value["OtherPharmacistNm"] :
            this.rxTransferFG.value["OrgPharmacistNm"],
            ReFillNum: this.PrescReFill.value["ReFillNum"]
        }​);
        this.originalTransferInfo = Object.assign({​}​, this.rxTransferFG.value);
        if (!this.rxTransferFG.value.IsRefillTransferred && this.transferType) {​
            this.refillNos = "";
            for (let i = this.rxTransferInfo.Refillno;
                 i <= this.rxTransferInfo.Aref; i++) {​
                this.refillNos = this.refillNos + i;
                if (i !== this.rxTransferInfo.Aref) {​
                    this.refillNos = this.refillNos + " , ";
                }​
            }​
        }​
    }​
    getPharmcyDetails() {​
        const Id = this.rxTransferFG.controls["XferPharmId"].value;
        this._rxTransferDet.getPharmacyDetails(Id).pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {​
            if (resp) {​
                this.pharmcyDet.TransferPharmacy = resp["TransferPharmacies"];
                this.pharmcyDet.Phone = resp["Phone"];
                if (this.pharmcyDet.Phone) {​
                    if(this.pharmcyDet.TransferPharmacy)
                        this.pharmcyDet.TransferPharmacy['FullAddress'] = this._patientUtil.getPatientAddress({
                            address1: this.pharmcyDet.TransferPharmacy.AddressLine1, 
                            city: this.pharmcyDet.TransferPharmacy.CityName, 
                            state: this.pharmcyDet.TransferPharmacy.StateName,
                            zipcode: this.pharmcyDet.TransferPharmacy.ZipCode 
                        }) 
                          if (this.pharmcyDet?.Phone?.length) {
                            const primaryPhones  = this.pharmcyDet?.Phone?.filter(pd => pd["PhoneCatId"] === 3);
                            this.Phone1 = primaryPhones  && primaryPhones.length ? primaryPhones [0]["Phone"] : null;
                            this.Phone2 = primaryPhones  && primaryPhones.length > 1 ? primaryPhones [1]["Phone"] : null;
                            const fax = this.pharmcyDet?.Phone?.filter(pd => pd["PhoneCatId"] === 4);
                            this.Fax = fax && fax.length ? fax[0]["Phone"] : null;
                        } else {
                            this.Phone1 = null;
                            this.Phone2 = null;
                            this.Fax = null;
                        }
                  
                }​ else {​
                    this.Phone1 = null;
                    this.Phone2 = null;
                    this.Fax = null;
                }​
                if (this.pharmcyDet) {​
                    this.citySelected = new City();
                    this.citySelected.Id = this.pharmcyDet.TransferPharmacy?.CityId;
                    this.citySelected.Name = this.pharmcyDet.TransferPharmacy?.CityName;
                    this.citySelected.StateId = this.pharmcyDet.TransferPharmacy?.StateId;
                    this.stateSelected = new State();
                    this.stateSelected.Id = this.pharmcyDet.TransferPharmacy?.StateId;
                    this.stateSelected.Name = this.pharmcyDet.TransferPharmacy?.StateName;
                }​
                // for (const key in this.pharmcyDet) {​
                //     if (key === "Phone") {​
                //         this.generateFA(key, this.pharmcyDet.Phone);
                //     }​
                // }​
            }​
        }​);
    }​
    get PrescReFill(): FormGroup {​
        return this.rxFG.get("PrescReFill") as FormGroup;
    }​
    get RefillInsu(): FormGroup {​
        return this.rxFG.get("RefillInsu") as FormGroup;
    }​
    get Prescription(): FormGroup {​
        return this.rxFG.get("Prescription") as FormGroup;
    }​
    get SigCodes(): FormGroup {​
        return this.rxFG.get("SigCodes") as FormGroup;
    }​
    get RxBill(): FormGroup {​
        return this.rxFG.get("RxBill") as FormGroup;
    }​
    openRXIN() {​
        this.RXINPOPUP = true;
        this.modalRef = this._modalService.open(this.RXINMODAL, {​
            size: "lg",
            windowClass: environment.IseRxTransferRequest ? "rx-transfer_modal" : "",
            keyboard: false,
            centered : true
        }​);
    }​
    closeModal() {​
        if (this.modalRef)​ {
            this.modalRef.close();
            this.modalRef = null;
            const closePopup = this._rxStore.OpenTransferInfo$["source"]["value"];
            if(closePopup && closePopup?.value) {
                this._rxStore._CloseTransferInfo$.next(closePopup);
                this._rxStore._OpenTransferInfo$.next(null);
            }
        }
        if(this.rxFG?.value['RxNotes']) {
            let rxNotes = this.rxFG?.value['RxNotes']?.find((item: any) => { return  item?.IsfromTransferIn});
            if(rxNotes && Array.isArray(rxNotes["PopupScreenCodes"])) {
                rxNotes["PopupScreenCodes"] = rxNotes["PopupScreenCodes"]?.length ? rxNotes["PopupScreenCodes"]?.toString() : null;
                this.rxFG.value['RxNotes'] = rxNotes;        
            }
            if (this.rxTransferDetails && this.rxTransferDetails["rxTransferIn"] && this.rxTransferDetails["rxTransferOut"]) {​
                this.getTranferDet();
            }​ else {​
                this.IsPopUpClosed.emit(null);
            }​
        }
    }​
    setSaveButton(val: any) {
        if(val?.Note) {
            if(this.rxFG?.value['RxNotes']?.length) {
                let rxNotes: any = this.rxFG?.value['RxNotes'];
                rxNotes = rxNotes.filter((item: any) => { return  !item?.IsfromTransferIn});
                val.Note["PopupScreenCodes"] = val.Note["PopupScreenCodes"]?.length ? val.Note["PopupScreenCodes"]?.toString() : null;
                val.Note["IsfromTransferIn"]   = true;
                val.Note["IsShownAsPopup"]  = val.Note["PopupScreenCodes"]?.length ? true : false;  
                rxNotes.push(val.Note);
                this.rxFG?.controls['RxNotes'].patchValue(rxNotes);
            } else {
                this.rxFG?.controls['RxNotes'].patchValue([val?.Note]);
            }
        }
        if (val) {​
            if(!val.targetPharmacy) 
                val.targetPharmacy = this.rxFG?.value?.selectedeRxRecord?.TargetPharmacyDetails;
            this._rxStore.storeTransfrInInfo(val);
            this.closeModal();
        }​
        this.saveRXIN = false;
        this.IsPopUpClosed.emit(null);
    }​
    saveNewRxTXIN(val?: any) {​
        this.saveRXIN = null;        
        if (val) {​
            setTimeout(()=> {
                this.saveRXIN = val;
            },100)
        }​
    }​
    async saveEditRxXfer(type?: any) {​
        const data = new XferInfoEdit();
        data["CheckInOrOut"] = this.transferType;
        if (this.transferType) {​
            data["rxTransferOut"] = this.rxTransferFG.getRawValue();
            data["rxTransferOut"]["OtherPharmacistNm"] = this.rxTransferFG.value["OrgPharmacistNm"];
            data["rxTransferOut"]["FaxNumber"] = this.faxFG.value.fax
        } else {
            data["rxTransferIn"] = this.rxTransferFG.getRawValue();
        }​
        const resp = await this._rxTransferDet.updateXferInfo(data).toPromise();
        if (resp) {​
            const transferInNotes  = this.rxTransferFG?.value?.Notes;
            if(environment.IseRxTransferRequest && transferInNotes && transferInNotes.IsUpdate  && transferInNotes.xNote  && (!transferInNotes.NoteCatId || transferInNotes.Name)) {
                // If Notes available To update the Notes when mark as Transfer In
                 const notesCatList: any = this._commonServ.notesCatList$["source"]["value"];
                                                const mainCat = notesCatList.find((val: any) => { if (val.CategoryName.toUpperCase() === NotesMainCat.RxAnnonations.toUpperCase()) return val });
                                                if(transferInNotes.NoteCatId){
                                                    this._drugServ.addoRUpdateNoteCategory(
                                                    {
                                                      Name: transferInNotes.Name,
                                                      NoteCategoryId: mainCat?.CategoryId,
                                                      IsActive: true,
                                                      CreatedDtTm: null,
                                                      Id: 0
                                                    },
                                                    "SAVE"
                                                  ).subscribe((resp: number) => {
                                                    if (resp) {
                                                      this.getNotesSubacatList({
                                                        Name: transferInNotes.Name,
                                                        pharmacistNotes:transferInNotes
                                                      });
                                                    }
                                                  });
                                                }


            } else if(environment.IseRxTransferRequest && transferInNotes && transferInNotes.IsUpdate  && transferInNotes.xNote  && transferInNotes.NoteCatId) { 
                this.updateNotesLog(transferInNotes);
            } else if(environment.IseRxTransferRequest && transferInNotes) {
                transferInNotes["PopupScreenCodes"] = transferInNotes["PopupScreenCodes"]?.length ? transferInNotes["PopupScreenCodes"]?.toString() : null;
                transferInNotes["IsfromTransferIn"]   = true;
                transferInNotes["IsShownAsPopup"]  = transferInNotes["PopupScreenCodes"]?.length ? true : false;  
                if(transferInNotes["NoteCatId"]){
                    this._notesLogSvc
                    .addNotesLog(NotesMainCat.RxAnnonation, (this.rxFG?.value?.Prescription?.Id ?
                        this.rxFG?.value?.Prescription?.Id : 0), 
                        {Note: [transferInNotes] , NoteCat: null, AnnotationNotes : []}).toPromise();
                }
            }
            if (type && type === "print") {​
                await this.printInfo();
            } else if (type && type === 'fax') {
                this.fax();
            }
            this.closeModal();
            // To audit the transfer in details
             this._auditUtils.saveAuditChange(
                                this.originalTransferInfo,
                                this.rxTransferFG.value,
                                "EditRx",
                                "Rx",
                               this.rxFG?.value?.PrescReFill?.Id,
                                new RxTransferInOut().rxTransferInOut,
                            );
        }​
    }​
    updateNotesLog(transferInNotes) {
        transferInNotes["PopupScreenCodes"] = transferInNotes["PopupScreenCodes"]?.length ? transferInNotes["PopupScreenCodes"]?.toString() : null;
        transferInNotes["IsfromTransferIn"]   = true;
        transferInNotes["IsShownAsPopup"]  = transferInNotes["PopupScreenCodes"]?.length ? true : false;  
        this._notesLogSvc.updateNotesLog({Note: [transferInNotes] , PrescrefillId : this.rxFG?.value?.PrescReFill?.Id , AnnotationNotes : [], NoteCat : null}).toPromise();
    }
    getNotesSubacatList(catObj?: any) {
      this._notesLogSvc
      .getNotesLog(
        NotesMainCat.RxAnnonation,0,
        "1973-01-01",
        moment(Date.now()).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN),
          new SearchNoteParams()
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((resp: any) => {
          if(resp)
          {
              if(catObj?.Name) {
                let manualSubCat = resp?.NoteCat?.find((item: any) => (catObj.Name.toUpperCase() === item?.Name?.toUpperCase()));
                if(catObj?.pharmacistNotes) {
                    catObj.pharmacistNotes.NoteCatId  =  manualSubCat ? manualSubCat.Id : 0;
                    this.updateNotesLog(catObj.pharmacistNotes);
                }
              }
          }
      });
    }

    
    async printInfo() {​
        const rxInfo = this.rxFG.getRawValue();
        const xRfInfoP = {​FromPrescRefillId: rxInfo.PrescReFill.Id,
            transferType: this.transferType ? "TransferOut" : "TransferIn", RxNum: rxInfo.Prescription.PrescNum}​;
        const presp = await this._rxTransferDet.printReport(xRfInfoP).toPromise();
        if (presp && presp.size > 0 && presp.type === "application/pdf") {​
            await this.printReport(presp);
        }​
    }​
    printReport(datToPrint) {​
        const newBlob = new Blob([datToPrint], {​ type: "application/pdf" }​);
        const reader = new FileReader();
        reader.readAsDataURL(newBlob);
        reader.onloadend = function () {​
            const base64data = reader.result;
            this._printser.printPdf(base64data);
        }​.bind(this);
    }
    
    transferSingleNotes(notes) {
        if(notes) {
      this.rxTransferFG.controls['Notes'].patchValue(notes);
      const hasNotes = notes.xNote && notes.xNote.trim() !== '' && notes.xNote !== '<br>';
      const hasSubcategory = notes.NoteCatId || notes.Name;
      this.isNotesInvalid = hasNotes && !hasSubcategory;
    } else {
      this.isNotesInvalid = false;
    }
    }

    selectedPharmDetails(pharmcy) {
            if(pharmcy) {
                this.pharmcyDet.TransferPharmacy.PharmName = pharmcy?.PharmName;
                this.pharmcyDet.TransferPharmacy.NPINum = pharmcy?.NPINum;
                this.pharmcyDet.TransferPharmacy.StateName = pharmcy?.StateName;
                this.pharmcyDet.TransferPharmacy.CityName = pharmcy?.CityName;
                this.pharmcyDet.TransferPharmacy.AddressLine1 = pharmcy?.AddressLine1;
                this.pharmcyDet.TransferPharmacy.ZipCode = pharmcy?.ZipCode;
                this.pharmcyDet.TransferPharmacy.CountryId = pharmcy?.CountryCode;
                this.pharmcyDet.TransferPharmacy.DEANum = pharmcy?.DEANum;
                this.pharmcyDet.TransferPharmacy.NCPDPID = pharmcy?.NCPDPID;
                this.pharmcyDet.TransferPharmacy.CountryCode = pharmcy?.CountryCode;
                this.pharmcyDet.TransferPharmacy.PharmId = pharmcy?.PharmId;
                this.pharmcyDet.TransferPharmacy.FullAddress = this._patientUtil.getPatientAddress({
                    address1: pharmcy?.AddressLine1, 
                    city: pharmcy?.CityName, 
                    state: pharmcy?.StateName,
                    zipcode: pharmcy?.ZipCode 
                });
                this.Phone1 = pharmcy?.Phone;
                this.Fax = pharmcy?.Fax;
                if (this.pharmcyDet?.TransferPharmacy) {
                    this.citySelected = new City();
                    this.citySelected.Id = pharmcy?.CityId;
                    this.citySelected.Name = pharmcy?.CityName;
                    this.citySelected.StateId = pharmcy?.StateId;
                    this.stateSelected = new State();
                    this.stateSelected.Id = pharmcy?.StateId;
                    this.stateSelected.Name = pharmcy?.StateName;
                }
            } else {
                this.pharmcyDet = null;
                this.pharmcyDet = new PharmacyData();
                this.Phone1 = null;
                this.Fax = null
            }
            
        }
    updateFax() {
        this.oldFax = this.faxFG.value["fax"] ? this.faxFG.value["fax"] : this.Fax;
        this.faxFG.controls["fax"].patchValue(this.Fax);
        this.modalRef2 = this._modalService.open(this.UPDATE, {
            centered: true,
            backdrop: false,
            windowClass: "large--content"
        });
    }
    updateFaxToPharm() {
        if (this.faxFG.valid) {
            this.faxChanged();
            // this.modalRef3 = this._modalService.open(this.FAXCHANGE, {
            //     centered: true,
            //     backdrop: false,
            //     windowClass: "large--content"
            // });
        }    
    }

    closeFaxModal() {
        if (this.modalRef2)​ {
            this.modalRef2.close();
            this.modalRef2 = null;
        }
    }

    faxChanged() {
        this.closeModalForFaxChanged(true);
        this.isFaxchanged = true;
        this.closeFaxModal();
        this.saveEditRxXfer('fax');
    }

    closeModalForFaxChanged(val?: any) {
        if (this.modalRef3) {
            this.modalRef3.close();
            this.modalRef3 = null;
            }
        if (!val) {
            if (this.oldFax !== this.faxFG.value.fax) {
                this.faxFG.controls["fax"].patchValue(this.oldFax);
            }
        }
    }

    openFax() {
        if (this.faxFG.valid) {
            this.closeFaxModal();
            this.faxFG.controls["tofax"].patchValue(this.faxFG.value.fax);
            this.Fax = this.faxFG.value.fax;
            this.saveEditRxXfer('fax');
        }
    }


    async fax() {
            this.getPrintObject();
            const sendFax = {
                FaxTo:  this.pharmcyDet && this.pharmcyDet?.TransferPharmacy?.PharmName ? this.pharmcyDet?.TransferPharmacy?.PharmName : null,
                FaxFrom: this._userService.getToken("PharmacyName"),
                FaxNumber: this.faxFG.value.fax,
                RxNo: this.rxTransferFG.value.prescnumid,
                transferTo: this.prtObj,
                FaxPrefix: this._commonServ.getSetttingValue("FaxAndReportsSettings", "Fax_Prefix")
            };
    
            this.subscriptions.add(
                this._rxSer.sendFax(sendFax).subscribe(
                    (resp) => {
                        if (resp) {
                            this._alertService.success("Fax sent successfully.");
                            this.closeModal(); // Assuming this closes the modal for fax.
                        } else {
                            this._alertService.error("Fax sent unsuccessfully.");
                        }
                        if (this.subscriptions) {
                            this.subscriptions.unsubscribe();
                            this.subscriptions = new Subscription();
                        }
                    }));
        }

    getPrintObject() {
        this.prtObj = {
            FromPrescRefillId: this.rxFG?.value?.PrescReFill?.Id,
            PharmacyId: null,
            TenantId: null,
            TransferDate: this.rxTransferFG.value.TransferDtTm,
            phone : this.pharmcyDet && this.pharmcyDet.Phone && this.pharmcyDet.Phone[0] && this.pharmcyDet.Phone[0].Phone ? this.pharmcyDet.Phone[0].Phone : null,
            OtherPharmacist: this.rxTransferFG.value.OrgPharmacistNm,
            PharmacyName: this.pharmcyDet && this.pharmcyDet.TransferPharmacy && this.pharmcyDet.TransferPharmacy.PharmName ? this.pharmcyDet.TransferPharmacy.PharmName : null,
            FaxNum: this.pharmcyDet && this.pharmcyDet.Phone && this.pharmcyDet.Phone[2] && this.pharmcyDet.Phone[2].Phone ? this.pharmcyDet.Phone[2].Phone : null,
            ReceivingRPH: this.recvRph,
            Remarks: this.rxTransferFG.value.Remarks,
            Refills: this.rxTransferFG.value.RefillsTransferredList,
            Qty : this.rxTransferFG.value.TotalQty,
            PartialFillQty: this.rxTransferFG.value.PartialFillQty,
        };
    }

    async clickToCallOutBond(mobile,from) {
        let resp;
        let callRequest = this._comnUtil.clickToOutBondcall(mobile);
        const patient = this.rxFG.get("Patient").value;
        this.pharmcyDet.TransferPharmacy["patientInfo"] = this.rxTransferInfo["patientInfo"] = patient ? { name: patient?.fullname, id: patient?.patientid, dob: patient?.dob, phoneNumber: (patient?.mobile || patient?.telephone || patient?.worknumber), gender: patient?.gender, addressLine1: patient?.address1, state: patient?.state, city: patient?.city, zipCode: patient?.zipcode } : null;
        if(callRequest && mobile && this.isIvrEnabled) {
            if(callRequest?.ivrVendor === 1) {
                resp = await this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                if(resp) this._comnUtil.openCallLogPopup(mobile,(from === "Prescriber" ? this.rxTransferInfo : this.pharmcyDet?.TransferPharmacy),from);
                else { this._alertService.error(MsgConfig.IVR_Call_Error); this._commonServ._isCallOngoing$.next(null); }
            } else if(callRequest?.ivrVendor === 2) {
                this._commonServ.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                this._comnUtil.openCallLogPopup(mobile,(from === "Prescriber" ? this.rxTransferInfo : this.pharmcyDet?.TransferPharmacy),from);
            }
        } 
    }
    
    ngOnDestroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();​
        sessionStorage.removeItem("fromPaGrid");
        this._storageService.getWijmoGridDataInSession(this.activeHeaders,"rxTransferListWj");
    }
}​





